import BackButton from '@/components/back-button'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/static/_layout/quick-help')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation('auth')
  return (
    <div className="w-full px-4 md:px-12 lg:px-[140px] pb-[200px] flex flex-col gap-8">
      <BackButton />
      <div>
        <h1 className="heading-1! max-w-[500px]">
          {t('quickHelp.title')}
        </h1>

        <div className="pt-10 grid grid-cols-1 gap-12  lg:gap-36 md:grid-cols-2">
          {/* Workers */}
          <div className="flex flex-col">
            <div className="mb-6">
              <img
                src="/workers-circle.svg"
                alt={t('quickHelp.workersAlt')}
                width={100}
                height={100}
              />
            </div>
            <ul className="space-y-4">
              <li>
                <p className="body font-bold">{t('quickHelp.worker.browseTitle')}</p>
                <p className="body">
                  {t('quickHelp.worker.browseBody')}
                </p>
              </li>
              <li>
                <p className="body font-bold">{t('quickHelp.worker.detailsTitle')}</p>
                <p className="body">
                  {t('quickHelp.worker.detailsBody')}
                </p>
              </li>
              <li>
                <p className="body font-bold">{t('quickHelp.worker.applyTitle')}</p>
                <p className="body">
                  {t('quickHelp.worker.applyBody')}
                </p>
              </li>
              <li>
                <p className="body font-bold">{t('quickHelp.worker.scheduleTitle')}</p>
                <p className="body">
                  {t('quickHelp.worker.scheduleBody')}
                </p>
              </li>
              <li>
                <p className="body font-bold">{t('quickHelp.worker.earningsTitle')}</p>
                <p className="body">
                  {t('quickHelp.worker.earningsBody')}
                </p>
              </li>
              <li>
                <p className="body font-bold">
                  {t('quickHelp.worker.profileTitle')}
                </p>
                <p className="body">
                  {t('quickHelp.worker.profileBody')}
                </p>
              </li>
            </ul>
          </div>

          {/* Business */}
          <div className="flex flex-col">
            <div className="mb-6">
              <img
                src="/business-circle.svg"
                alt={t('quickHelp.businessAlt')}
                width={100}
                height={100}
              />
            </div>
            <ul className="space-y-4">
              <li>
                <p className="body font-bold">{t('quickHelp.business.postTitle')}</p>
                <p className="body">
                  {t('quickHelp.business.postBody')}
                </p>
              </li>
              <li>
                <p className="body font-bold">{t('quickHelp.business.applicantsTitle')}</p>
                <p className="body">
                  {t('quickHelp.business.applicantsBody')}
                </p>
              </li>
              <li>
                <p className="body font-bold">{t('quickHelp.business.assignTitle')}</p>
                <p className="body">
                  {t('quickHelp.business.assignBody')}
                </p>
              </li>
              <li>
                <p className="body font-bold">{t('quickHelp.business.monitorTitle')}</p>
                <p className="body">
                  {t('quickHelp.business.monitorBody')}
                </p>
              </li>
              <li>
                <p className="body font-bold">{t('quickHelp.business.paymentsTitle')}</p>
                <p className="body">
                  {t('quickHelp.business.paymentsBody')}
                </p>
              </li>
              <li>
                <p className="body font-bold">{t('quickHelp.business.reviewTitle')}</p>
                <p className="body">
                  {t('quickHelp.business.reviewBody')}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  )
}
